{
  "analytics.bugs.empty": "No bugs reported",
  "analytics.bugs.emptyHint": "Errors and rejections will cluster here as they happen.",
  "analytics.bugs.fallbackMessage": "Error",
  "analytics.bugs.title": "Bugs",
  "analytics.campaigns.byCampaign": "Campaign",
  "analytics.campaigns.byContent": "Content",
  "analytics.campaigns.byMedium": "Medium",
  "analytics.campaigns.bySource": "Source",
  "analytics.campaigns.byTerm": "Term",
  "analytics.campaigns.direct": "Direct: {count}",
  "analytics.campaigns.empty": "No campaign traffic in this interval — add ?utm_source=…&utm_campaign=… to your links.",
  "analytics.campaigns.groupBy": "Group campaigns by",
  "analytics.campaigns.needsServer": "Campaigns need the new analytics server — not available on this deployment yet.",
  "analytics.campaigns.none": "(none)",
  "analytics.campaigns.openSessionsFor": "Open sessions for {label}",
  "analytics.campaigns.reading": "Reading campaigns…",
  "analytics.campaigns.title": "Campaigns",
  "analytics.count.bugMany": "{count} bugs",
  "analytics.count.bugOne": "{count} bug",
  "analytics.count.clusterMany": "{count} clusters",
  "analytics.count.clusterOne": "{count} cluster",
  "analytics.count.entryMany": "{count} entries",
  "analytics.count.entryOne": "{count} entry",
  "analytics.count.errorMany": "{count} errors",
  "analytics.count.errorOne": "{count} error",
  "analytics.count.eventMany": "{count} events",
  "analytics.count.eventOne": "{count} event",
  "analytics.count.locationMany": "{count} locations",
  "analytics.count.locationOne": "{count} location",
  "analytics.count.logMany": "{count} logs",
  "analytics.count.logOne": "{count} log",
  "analytics.count.pageViewMany": "{count} page views",
  "analytics.count.pageViewOne": "{count} page view",
  "analytics.count.requestMany": "{count} requests",
  "analytics.count.requestOne": "{count} request",
  "analytics.count.sessionMany": "{count} sessions",
  "analytics.count.sessionOne": "{count} session",
  "analytics.count.updateMany": "{count} updates",
  "analytics.count.updateOne": "{count} update",
  "analytics.count.userMany": "{count} users",
  "analytics.count.userOne": "{count} user",
  "analytics.count.viewMany": "{count} views",
  "analytics.count.viewOne": "{count} view",
  "analytics.count.visitorMany": "{count} visitors",
  "analytics.count.visitorOne": "{count} visitor",
  "analytics.dailyBand.caption": "{parts} over 12 days",
  "analytics.dailyBand.needsServer": "Daily history needs the new analytics server — not available on this deployment yet.",
  "analytics.dailyBand.title": "Last 12 days",
  "analytics.demographics.empty": "No demographic data yet — sessions need to land first.",
  "analytics.demographics.title": "Demographics",
  "analytics.demographics.unknownOrigin": "{sessions} without an origin (local dev / anonymized exits)",
  "analytics.duration.days": "{d}d {h}h",
  "analytics.duration.hours": "{h}h {m}m",
  "analytics.duration.minutes": "{m}m {s}s",
  "analytics.duration.seconds": "{s}s",
  "analytics.events.empty": "No events yet",
  "analytics.events.emptyHint": "App and log events will appear here as they happen.",
  "analytics.events.title": "Events",
  "analytics.header.allProjects": "All projects",
  "analytics.header.approximate": "Approximate values derived client-side from the {count} most recent sessions — the server rollup endpoints didn't respond.",
  "analytics.header.interval": "Interval",
  "analytics.header.projectScope": "Project",
  "analytics.identity.anonymous": "Anonymous",
  "analytics.identity.session": "Session",
  "analytics.identity.someone": "Someone",
  "analytics.identity.user": "User {id}",
  "analytics.identity.userFallback": "User",
  "analytics.identity.visitor": "Visitor {id}",
  "analytics.identity.visitorFallback": "Visitor",
  "analytics.interval.all": "All",
  "analytics.interval.day": "24h",
  "analytics.interval.month": "30d",
  "analytics.interval.week": "7d",
  "analytics.kpi.activeNow": "active right now",
  "analytics.kpi.attributed": "{count} attributed",
  "analytics.kpi.avgSession": "Avg session",
  "analytics.kpi.bugs": "Bugs",
  "analytics.kpi.countries": "Countries",
  "analytics.kpi.events": "Events",
  "analytics.kpi.inWorkspace": "in this workspace",
  "analytics.kpi.members": "Members",
  "analytics.kpi.newReturning": "{new} new · {returning} returning",
  "analytics.kpi.nobodyActive": "nobody active",
  "analytics.kpi.onlineNow": "Online now",
  "analytics.kpi.openTasks": "Open tasks",
  "analytics.kpi.pageViews": "Page views",
  "analytics.kpi.projects": "Projects",
  "analytics.kpi.sessions": "Sessions",
  "analytics.kpi.visitors": "Visitors",
  "analytics.logs.bugs": "Bugs",
  "analytics.logs.collapseDetail": "Collapse detail",
  "analytics.logs.events": "Events",
  "analytics.logs.expandDetail": "Expand detail",
  "analytics.logs.loadError": "Couldn't load logs — {error}",
  "analytics.logs.network": "Network",
  "analytics.logs.requestFailed": "request failed",
  "analytics.logs.sectionsLabel": "Logs sections",
  "analytics.logs.sessions": "Sessions",
  "analytics.logs.title": "Logs",
  "analytics.logs.users": "Users",
  "analytics.logs.verbose": "Verbose",
  "analytics.map.empty": "No geo-tagged sessions in this window yet",
  "analytics.map.hoverEmpty": "· no sessions yet",
  "analytics.map.label": "World map of sessions by country",
  "analytics.map.modeSessions": "Sessions",
  "analytics.map.modeUsers": "Users",
  "analytics.map.unknown": "Unknown",
  "analytics.meta.activity": "Activity",
  "analytics.meta.app": "App",
  "analytics.meta.bugs": "Bugs",
  "analytics.meta.campaign": "Campaign",
  "analytics.meta.context": "Context",
  "analytics.meta.count": "Count",
  "analytics.meta.country": "Country",
  "analytics.meta.detail": "Detail",
  "analytics.meta.device": "Device",
  "analytics.meta.domain": "Domain",
  "analytics.meta.duration": "Duration",
  "analytics.meta.env": "Env",
  "analytics.meta.environment": "Environment",
  "analytics.meta.firstSeen": "First seen",
  "analytics.meta.health": "Health",
  "analytics.meta.hook": "Hook",
  "analytics.meta.kind": "Kind",
  "analytics.meta.landingPath": "Landing path",
  "analytics.meta.landingReferrer": "Landing referrer",
  "analytics.meta.lastSeen": "Last seen",
  "analytics.meta.level": "Level",
  "analytics.meta.location": "Location",
  "analytics.meta.medium": "Medium",
  "analytics.meta.metric": "Metric",
  "analytics.meta.new": "New",
  "analytics.meta.pageViews": "Page views",
  "analytics.meta.payload": "Payload",
  "analytics.meta.release": "Release",
  "analytics.meta.returning": "Returning",
  "analytics.meta.route": "Route",
  "analytics.meta.sample": "Sample",
  "analytics.meta.samplePayload": "Sample payload",
  "analytics.meta.screen": "Screen",
  "analytics.meta.sessions": "Sessions",
  "analytics.meta.source": "Source",
  "analytics.meta.started": "Started",
  "analytics.meta.time": "Time",
  "analytics.meta.timezone": "Timezone",
  "analytics.meta.type": "Type",
  "analytics.meta.url": "URL",
  "analytics.meta.userAgent": "User agent",
  "analytics.meta.utmCampaign": "UTM campaign",
  "analytics.meta.utmContent": "UTM content",
  "analytics.meta.utmMedium": "UTM medium",
  "analytics.meta.utmSource": "UTM source",
  "analytics.meta.utmTerm": "UTM term",
  "analytics.meta.verbose": "Verbose",
  "analytics.meta.visitor": "Visitor",
  "analytics.meta.zone": "Zone",
  "analytics.network.empty": "No network requests yet",
  "analytics.network.emptyHint": "Fetch and XHR calls will appear here as sessions make them.",
  "analytics.network.title": "Network",
  "analytics.onChanges.title": "Analytics on changes",
  "analytics.page.bugs": "Bugs · Analytics",
  "analytics.page.events": "Events · Analytics",
  "analytics.page.logs": "Logs",
  "analytics.page.logsBugs": "Bugs / Logs",
  "analytics.page.logsEvents": "Events / Logs",
  "analytics.page.logsNetwork": "Network / Logs",
  "analytics.page.logsSession": "Session / Logs",
  "analytics.page.logsSessions": "Sessions / Logs",
  "analytics.page.logsUsers": "Users / Logs",
  "analytics.page.logsVerbose": "Verbose / Logs",
  "analytics.page.map": "Analytics · Map",
  "analytics.page.projects": "Analytics",
  "analytics.page.session": "Session · Analytics",
  "analytics.page.sessions": "Sessions · Analytics",
  "analytics.page.visitors": "Visitors · Analytics",
  "analytics.page.workspace": "Workspace Analytics",
  "analytics.session.back": "← Back to sessions",
  "analytics.session.empty": "No events recorded",
  "analytics.session.emptyHint": "Nothing was captured for this session yet.",
  "analytics.session.familyProject": "Project · {project}",
  "analytics.session.familyWorkspace": "Workspace",
  "analytics.session.openVisitor": "Open this visitor’s sessions",
  "analytics.session.sequence": "session #{number}",
  "analytics.session.unknownProject": "unknown",
  "analytics.sessions.clearFilter": "Clear filter",
  "analytics.sessions.empty": "No sessions yet",
  "analytics.sessions.emptyHint": "Sessions will appear here as people use your projects.",
  "analytics.sessions.title": "Sessions",
  "analytics.topPages.empty": "No page views in this interval yet.",
  "analytics.topPages.title": "Top pages",
  "analytics.topReferrers.direct": "Direct: {count}",
  "analytics.topReferrers.empty": "No referrers in this interval yet.",
  "analytics.topReferrers.title": "Top referrers",
  "analytics.topReferrers.unknownHost": "unknown",
  "analytics.totals.allTime": "All time: {parts}",
  "analytics.totals.allTimeMissing": "All-time totals not reported by the server.",
  "analytics.totals.missingPageViews": "— page views",
  "analytics.totals.missingSessions": "— sessions",
  "analytics.totals.missingVisitors": "— visitors",
  "analytics.totals.needsServer": "Totals need the new analytics server — not available on this deployment yet.",
  "analytics.totals.reading": "Reading totals…",
  "analytics.totals.title": "Overall",
  "analytics.users.emptyHintUsers": "Users appear here once sessions land.",
  "analytics.users.emptyHintVisitors": "Visitors appear here as people open your projects.",
  "analytics.users.emptyUsers": "No users yet",
  "analytics.users.emptyVisitors": "No visitors yet",
  "analytics.users.titleUsers": "Users",
  "analytics.users.titleVisitors": "Visitors",
  "analytics.usersToday.noHourly": "{users} today — no hourly breakdown was reported for the last 24 hours.",
  "analytics.usersToday.now": "now",
  "analytics.usersToday.titleUsers": "Users today",
  "analytics.usersToday.titleVisitors": "Visitors today",
  "analytics.verbose.empty": "No verbose entries",
  "analytics.verbose.emptyHint": "Verbose console output will appear here as sessions produce it.",
  "analytics.verbose.title": "Verbose",
  "analytics.view.bugs": "Bugs",
  "analytics.view.events": "Events",
  "analytics.view.logs": "Logs",
  "analytics.view.map": "Map",
  "analytics.view.overview": "Overview",
  "analytics.view.sessions": "Sessions",
  "analytics.view.visitors": "Visitors",
  "analytics.weekly.pastWeek": "Past week",
  "analytics.weekly.thisWeek": "This week",
  "analytics.whosActive.empty": "No sessions in this workspace yet.",
  "analytics.whosActive.fallbackNotice": "No sessions in the last 5 min — showing the 20 most-recent visitors instead.",
  "analytics.whosActive.openSession": "Open session",
  "analytics.whosActive.title": "Who's active",
  "analytics.whosActive.toggleDetails": "Toggle session details",
  "analytics.window.allTime": "All time",
  "analytics.window.last24h": "Last 24 hours",
  "analytics.window.last30d": "Last 30 days",
  "analytics.window.last7d": "Last 7 days",
  "analytics.workspace.activeNow": "Active right now",
  "analytics.workspace.appHealth": "App health · 7 days",
  "analytics.workspace.comingUp": "Coming up",
  "analytics.workspace.eventFallback": "Event",
  "analytics.workspace.healthClear": "No errors in the last 7 days.",
  "analytics.workspace.healthError": "Couldn’t load error data — this is not an all-clear.",
  "analytics.workspace.healthPending": "Checking for errors…",
  "analytics.workspace.hintLast7d": "last 7 days",
  "analytics.workspace.hintNeedsServer": "needs the new analytics server",
  "analytics.workspace.hintReading": "reading…",
  "analytics.workspace.noActivity": "No app activity recorded yet.",
  "analytics.workspace.noLocations": "No member locations yet.",
  "analytics.workspace.openErrorLogs": "Open error logs →",
  "analytics.workspace.presenceEmpty": "Nobody active in the last 5 minutes.",
  "analytics.workspace.presenceError": "Couldn’t load presence data.",
  "analytics.workspace.presencePending": "Checking who’s active…",
  "analytics.workspace.remote": "Remote",
  "analytics.workspace.teamActivity": "Team activity this week",
  "analytics.workspace.unknownError": "Unknown error",
  "analytics.workspace.whereTeam": "Where the team is"
}
